<template>
  <v-dialog v-model="dialog" max-width="600" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card class="text-center">
      <v-card-title class="d-flex justify-center">Delete Case</v-card-title>
      <v-card-text>
        Are you sure you want to delete this case?
        <div class="red--text mt-2">
          All corresponding case data and patient data <br/> will be deleted and cannot be undone.
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between">
        <v-btn @click="cancel">Cancel</v-btn>
        <v-btn depressed color="error" @click="deleteCase">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import event, { Events } from '@/event'
import DateMixin from '@/mixins/DateMixin'

export default {
  name: 'DeleteBillDialog',
  mixins: [DateMixin],
  components: {},
  data: () => ({
    dialog: false
  }),
  methods: {
    open () {
      this.dialog = true
    },
    cancel () {
      this.dialog = false
    },
    async deleteCase () {
      try {
        await this.$axios.delete(this.$store.getters['Organization/apiUrl'] + '/case/' + this.$route.params.caseId)
          .then(() => {
            event.emit(Events.SUCCESS, 'Case deleted successfully')
            this.dialog = false
            this.$router.push({ name: 'ActiveCases' })
          })
      } catch (error) {
        event.emit(Events.ERROR, error.response.data.payload.message, 2000)
      }
    }
  }
}
</script>
